<template>
    <div 
        ref="fontList" :data-category="fontName.category.replace(new RegExp('-', 'g'), '')" 
        class="font-list-element" 
        :class="[ isActive 
            ?  'active' 
            : '' ]" 
        v-if="fontSettings[fontName.category.replace(new RegExp('-', 'g'), '')]">

        <h6>{{fontName.family}}</h6>

        <div 
            @click="toggleFontFamilyVariants" 
            class="toggle-click" 
            :class="isActive ?  'active' : '' ">

                {{fontName.variants.length}} {{fontName.variants.length === 1 ? 'style' : 'styles'}}
            
            <i :class="!isActive ?  'fas fa-angle-down' : 'fas fa-angle-up'"></i>

        </div>

        <transition name="slide-fade">

            <div class="font-picker-weight-list" v-show="isActive">

                <div v-for="(variant, index) in fontName.variants" :key="index" >

                        <input type="checkbox" 
                            @change="addOrRemoveFont(fontName.family, variant)"
                            :checked="isInSelectedFontsArray(fontName.family, variant)" 
                            :id="fontName.family.replace(new RegExp(' ', 'g'), '')+(variant.replace(new RegExp(' ', 'g'), ''))" />

                        <label :for="fontName.family.replace(new RegExp(' ', 'g'), '')+(variant.replace(new RegExp(' ', 'g'), ''))">
                            {{displayVariant(variant)}}
                        </label>
                        <i class="far fa-eye" 
                            v-b-tooltip.hover="{title: 'Click to view preview', placement: 'top', boundary: 'window'}"
                            @click="addPreviewFont(fontName.family, variant)">
                        </i>

                </div>
            </div>
        </transition>
    </div>
</template>



<script>
export default {
    props: ['fontName'],
    name: 'FontPickerNames',
    data() {
        return {
            isActive: false,
            selectedFonts: [],
            googleLinkFonts: [],

            showVariants: '',

            notChecked: false,
            isChecked: true,

            myCound: 1
        }
        
    },

    computed: {

        // to filter by category
        fontSettings() {
            return this.$store.state.fontCategories
        }

    },

    methods: {

        // display variant nicely
        displayVariant(variant) {

            switch(variant) {

                case '100':
                    return 'Thin 100'
                    break;
                
                case '100italic':
                    return 'Thin 100 Italic'
                    break;

                case '200':
                    return 'Extra-Light 200'
                    break;
                
                case '200italic':
                    return 'Extra-Light 200 Italic'
                    break;
                
                case '300':
                    return 'Light 300'
                    break;

                case '300italic':
                    return 'Light 300 Italic'
                    break;

                case 'regular':
                    return 'Regular 400'
                    break;
                
                case 'italic':
                    return 'Regular 400 Italic'
                    break;
                
                case '500':
                    return 'Medium 500'
                    break;
                
                case '500italic':
                    return 'Medium 500 Italic'
                    break;
                
                case '600':
                    return 'Semi-Bold 600'
                    break;
                
                case '600italic':
                    return 'Semi-Bold 600 Italic'
                    break;
                
                case '700':
                    return 'Bold 700'
                    break;
                
                case '700italic':
                    return 'Bold 700 Italic'
                    break;
                
                case '800':
                    return 'Extra-Bold 800'
                    break;
                
                case '800italic':
                    return 'Extra-Bold 800 Italic'
                    break;
                
                case '900':
                    return 'Black 900'
                    break;
                
                case '900italic':
                    return 'Black 900 Italic'
                    break;

                default: 
                    return variant

            }

        },

        // pre check checkboxes for fonts that are already in array (previously selected by user)
        isInSelectedFontsArray(fontfamily, variant) {

            variant = variant.replace('italic','i')
            if(variant === 'i'){
                variant = '400i'
            }
            if(variant === 'regular'){
                variant = '400'
            }

            let fontInGoogleFontsToLoad = fontfamily.replace(new RegExp(" ", "g"), '+')+':'+variant

            return this.$store.state.googleFontsToLoad.includes(fontInGoogleFontsToLoad ) ? true : false

        },

        // show preview font
        addPreviewFont(fontfamily, variant) {

            // add names for google request
            variant = variant.replace('italic','i')

            if(variant === 'i'){
                variant = '400i'
            }
            if(variant === 'regular'){
                variant = '400'
            }
            let previewFontFamily = fontfamily.replace(new RegExp(" ", "g"), '+')+':'+variant
            // set google link correct
            this.$store.state.fontPreview.fontFamilyGoogle = previewFontFamily

            // for use in css preview
            let fontStylecss = 'normal'
            let fontWeightcss = variant

            if( fontWeightcss.includes('i') ){
                fontWeightcss = fontWeightcss.replace('i', '')
                fontStylecss = 'italic'
            }

            // set all the css styles for preview
            this.$store.state.fontPreview.fontFamilyPreview = "'"+fontfamily+"'"
            this.$store.state.fontPreview.fontWeightPreview = fontWeightcss
            this.$store.state.fontPreview.fontStylePreview = fontStylecss

        },

        // show variants of font family
        toggleFontFamilyVariants() {
            this.isActive = !this.isActive;
            document.addEventListener('click', this.documentClick)
        },

        documentClick() {
            var el = this.$refs.fontList,
                target = event.target;

            if(el !== target && !el.contains(target)) {

                this.isActive = false
                document.removeEventListener('click', this.documentClick)
                
            } 
        },

        // add font to users fonts array
        addOrRemoveFont(fontFamily, fontWeight) {
            
            // create google font string
            fontWeight = fontWeight.replace('italic','i')

            if(fontWeight === 'i'){
                fontWeight = '400i'
            }

            if(fontWeight === 'regular'){
                fontWeight = '400'
            }

            let hrefFontFamily = fontFamily.replace(new RegExp(" ", "g"), '+')+':'+fontWeight

            // put in array when checkbox is checked
            if( event.target.checked === true ) {
                this.$store.state.googleFontsToLoad.push(hrefFontFamily)
            } else {
                // take out of array if it gets unchecked
                this.$store.state.googleFontsToLoad.splice( this.$store.state.googleFontsToLoad.indexOf(hrefFontFamily), 1 );
            }
    
        }
    }
    
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/Fontpickername.vue